import ProductHamburger from "./ProductHamburger";

export default ProductHamburger;
